import React from "react";

import type { JSX } from "react";

interface PaypalIconProps {
  className?: string;
  color?: string;
}

function PaypalIcon({ className, color }: PaypalIconProps): JSX.Element {
  return (
    <svg
      className={className}
      fill={color ?? "inherit"}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>PayPal icon</title>
      <path
        d="M12,26H7c-0.8,0-1.6-0.4-2.1-1c-0.5-0.6-0.7-1.4-0.5-2.2L8.7,4l0,0c0.3-1.2,1.3-2,2.6-2h8.6c2.3,0,4.4,1,5.9,2.8
		c1.4,1.8,2,4.1,1.5,6.4c-0.8,4-4.4,6.8-8.5,6.8h-3.2c-0.5,0-1,0.4-1.1,0.9L13,25.2C12.9,25.7,12.5,26,12,26z"
      />
      <path
        d="M12,26H7c-0.8,0-1.6-0.4-2.1-1c-0.5-0.6-0.7-1.4-0.5-2.2L8.7,4l0,0c0.3-1.2,1.3-2,2.6-2h8.6c2.3,0,4.4,1,5.9,2.8
		c1.4,1.8,2,4.1,1.5,6.4c-0.8,4-4.4,6.8-8.5,6.8h-3.2c-0.5,0-1,0.4-1.1,0.9L13,25.2C12.9,25.7,12.5,26,12,26z"
      />
      <path
        d="M29.3,11.3c0,0.1,0,0.2,0,0.3c-1,4.9-5.4,8.4-10.4,8.4h-2.5l-1.4,5.7C14.6,27.1,13.4,28,12,28h-2c0.1,0.4,0.2,0.7,0.5,1
	c0.5,0.6,1.2,0.9,2,0.9H17c0.5,0,0.9-0.3,1-0.7l1.4-5.5c0.1-0.4,0.5-0.6,0.9-0.6h2.9c3.7,0,7-2.5,7.7-6C31.3,15,30.7,12.8,29.3,11.3
	z"
      />
    </svg>
  );
}

export default PaypalIcon;
